export default "__VITE_ASSET__U56mOAeT__"